import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseResponse } from '../models/rest/baseResponse';

export interface AxxonDomain {
  DomainId: number;
  Name: string;
}

export interface AxxonCamera {
  Id: string;
  Name: string;
  AccessPoint: string;
  IsEnabled: boolean;
  IsActivated: boolean;
}

export interface IAxxonDomainsResponse extends BaseResponse {
  Data: AxxonDomain[];
}

export interface IAxxonCamerasResponse extends BaseResponse {
  Data: AxxonCamera[];
}

export interface IAxxonCameraLivPreviewResponse extends BaseResponse {
  FeedUrl: string;
}

@Injectable({ providedIn: 'root' })
export class AxxonService {
  constructor(private _httpClient: HttpClient) {}

  getAxxonDomains(): Observable<IAxxonDomainsResponse> {
    return this._httpClient.get<IAxxonDomainsResponse>('Axxon/Domains');
  }

  getAxxonCameras(DomainId: number): Observable<IAxxonCamerasResponse> {
    return this._httpClient.get<IAxxonCamerasResponse>(`Axxon/Domains/${DomainId}/Cameras`);
  }

  getAxxonCameraLivePreview(CameraId: string, DomainId: number): Observable<any> {
    return this._httpClient.get(`Axxon/Domains/${DomainId}/Cameras/${CameraId}/LivePreview`, {
      headers: new HttpHeaders({ 'Accept': 'image/jpeg' }),
      responseType: 'blob' as 'blob',
      observe: 'response'
    });
  }

  getAxxonCameraLive(CameraId: string, DomainId: number): Observable<IAxxonCameraLivPreviewResponse> {
    return this._httpClient.get<IAxxonCameraLivPreviewResponse>(`Axxon/Domains/${DomainId}/Cameras/${CameraId}/Live`);
  }
}
